import { Alert, Snackbar, Slide } from "@mui/material";
import { useState, forwardRef, useImperativeHandle } from "react";
import { PropTypes } from "prop-types";

const Notification = forwardRef(({ onClose, closeTimeoutSeconds }, ref) => {
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("");
  const [text, setText] = useState("");
  const [timeout, setTimeout] = useState(0);

  const vertical = 'bottom'
  const horizontal = 'right'

  useImperativeHandle(ref, () => ({
    openPopup(svrty, txt) {
      setSeverity(svrty);
      setText(txt);
      setTimeout(closeTimeoutSeconds * 1000);
      setOpen(true);
    }
  }))

  const handleClose = () => {
    setOpen(false);
    onClose();
  }

  return (
    <Snackbar open={open} autoHideDuration={timeout} onClose={handleClose}
      TransitionComponent={Slide}
      anchorOrigin={{ vertical, horizontal }}>
      <Alert
      onClose={handleClose}
      severity={severity}
      variant="filled"
      sx={{ width: '100%' }}
      >{text}</Alert>
    </Snackbar>
  )
})

Notification.defaultProps = {
  onClose: () => { },
  closeTimeoutSeconds: 3,
}

Notification.propTypes = {
  onClose: PropTypes.func,
  closeTimeoutSeconds: PropTypes.number,
}

Notification.displayName = "Notification";

export default Notification;